import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectElectricity = createSelector(selectJsonQuery, jsonQuery => getTermValue('electricity')(jsonQuery));
